document.addEventListener("DOMContentLoaded", (event) => {

    add_listeners();

    document.querySelectorAll('.pcard-variant-option').forEach((variantOptionContainer) => {
        let option;
        let selectedOption = variantOptionContainer.querySelector('.product-option-item[data-selected="true"]');
        
        if (selectedOption) {
            option = selectedOption;
        } else {
            option = variantOptionContainer.querySelector('.product-option-item:first-child');
        }

        if (!option) return;

        let p_card = option.closest('.sf__pcard');

        let variant_handle = option.getAttribute('data-value');
        let option_position = option.getAttribute('data-option-position');

        let product_handle = option.closest('div[data-product-url]').getAttribute('data-product-url').split('/').slice(-1)[0];

        fetch(window.Shopify.routes.root + `products/${product_handle}.js`)
            .then((response) => {

                return response.json();

            })
            .then((product) => {


                // Card sold-out state should reflect whole product availability,
                // not whether the first/selected swatch value is unavailable.
                if(!product.available){
                    p_card.classList.add('_custom-sold-out');
                }
                else{
                    p_card.classList.remove('_custom-sold-out');
                }



            })
            .catch((error) => {
                this.close();
                throw error;
            });



    });

    update_available_sizes_on_variant_change();

});

function add_listeners(){

    document.querySelectorAll('.pcard-variant-option .product-option-item').forEach((option) => {

        option.addEventListener('click', (event) => {

            let p_card = option.closest('.sf__pcard');

            let variant_handle = option.getAttribute('data-value');
            let option_position = option.getAttribute('data-option-position');

            let product_handle = option.closest('div[data-product-url]').getAttribute('data-product-url').split('/').slice(-1)[0];

            fetch(window.Shopify.routes.root + `products/${product_handle}.js`)
                .then((response) => {

                    return response.json();

                })
                .then((product) => {


                    // Keep card visible as in-stock when any variant is available.
                    if(!product.available){
                        p_card.classList.add('_custom-sold-out');
                    }
                    else{
                        p_card.classList.remove('_custom-sold-out');
                    }



                })
                .catch((error) => {
                    this.close();
                    throw error;
                });
        });



    });

}


function update_available_sizes_on_variant_change(){
    document.querySelectorAll('.pcard-variant-option .product-option-item').forEach((option) => {

        option.addEventListener('click', (event) => {

            let product, selected_color, unique_option_values, temp_values;

            let p_card = option.closest('.sf__pcard');
            let variant_handle = option.getAttribute('data-value');
            let option_position = option.getAttribute('data-option-position');
            let product_handle = option.closest('div[data-product-url]').getAttribute('data-product-url').split('/').slice(-1)[0];


            fetch(window.Shopify.routes.root + `products/${product_handle}.js`)
                .then((response) => {
                    return response.json();
                })
                .then((product) => {


                    let current_variants = product.variants.filter((variant) => variant['option' + option_position] == variant_handle);

                    if(current_variants){
                        let available_sizes = current_variants
                            .filter(variant => variant.available) // filter only available variants
                            .map(variant => {
                                if(option_position == '1') return variant.option2;
                                if(option_position == '2') return variant.option1;
                                return variant.option2; // fallback
                            });


                        let custom_available_sizes = p_card.querySelector('._custom-available-sizes');

                        custom_available_sizes.innerHTML = "";

                        if(available_sizes.length > 10){
                            let div = document.createElement("div");
                            div.className = "_custom-available-size";
                            div.innerHTML = available_sizes.length + " størrelser på lager";
                            custom_available_sizes.appendChild(div);
                        }
                        else {
                            available_sizes.forEach((size) => {
                                let div = document.createElement("div");
                                div.className = "_custom-available-size";
                                div.innerHTML = size;
                                custom_available_sizes.appendChild(div);

                            });
                        }
                    }

                })
                .catch((error) => {
                    this.close();
                    throw error;
                });
        });

    });
}

document.querySelector('#m-form-search').addEventListener('input', (event) => {

    const search_results_wrapper = document.querySelector("#product-search");


    const config = { attributes: true, childList: true, subtree: true };

    const callback = (mutationList, observer) => {
        for (const mutation of mutationList) {
            if (mutation.type === "childList") {
                add_listeners();
            }
        }
    };

    const observer = new MutationObserver(callback);

    observer.observe(search_results_wrapper, config);

});